import { render, staticRenderFns } from "./ConfigSent.vue?vue&type=template&id=4ca234b1&scoped=true&"
import script from "./ConfigSent.vue?vue&type=script&lang=ts&"
export * from "./ConfigSent.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigSent.vue?vue&type=style&index=0&id=4ca234b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca234b1",
  null
  
)

export default component.exports